import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { getDataFromAPI } from "../../../HandleAPICalls/actions";
import { toastr } from "react-redux-toastr";
import SubCategoryCreateComponent from "./component";

const SubCategoryCreateContainer = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const category = location.state?.categoryData;

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    status: "active",
  });
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState("");
  const [imagePath, setImagePath] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [createdItemName, setCreatedItemName] = useState("");
  const [createdItemId, setCreatedItemId] = useState("");

  const fileInputRef = useRef(null);

  // S3 Base URL
  const S3_BASE_URL = "https://s3.ap-south-1.amazonaws.com/daalchini/dcprod/";

  const isFormValid = formData.name.trim() !== "";

  // Upload image to S3
  const uploadImageToS3 = async (file) => {
    if (!file) return null;
    
    const formDataUpload = new FormData();
    formDataUpload.append("file", file);
    
    return new Promise((resolve, reject) => {
      props.getDataFromAPI(
        "/partner/api/v2/s3upload/machine-image",
        "POST",
        formDataUpload,
        (response) => {
          const uploadedPath = response?.image_path || response?.data?.image_path || response?.path || response?.url;
          
          if (!uploadedPath) {
            reject(new Error("No image path received from upload API"));
            return;
          }
          
          toastr.success("Success", "Image uploaded successfully");
          resolve(uploadedPath);
        },
        (err) => {
          toastr.error("Failed", "Unable to upload image");
          reject(err);
        }
      );
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleStatusChange = (status) => {
    setFormData(prev => ({ ...prev, status }));
  };

  const handleImageChange = async (file) => {
    if (!file) {
      setImagePreview("");
      setImagePath("");
      setImageFile(null);
      return;
    }

    if (!file.type.match('image.*')) {
      toastr.error("Error", "Please upload an image file");
      return;
    }
    
    if (file.size > 5 * 1024 * 1024) {
      toastr.error("Error", "Image size should be less than 5MB");
      return;
    }
    
    // Show preview immediately
    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreview(reader.result);
    };
    reader.readAsDataURL(file);
    
    // Upload image to S3
    setIsImageUploading(true);
    try {
      const uploadedPath = await uploadImageToS3(file);
      setImagePath(uploadedPath);
      setImageFile(file);
    } catch (error) {
      console.error("Image upload failed:", error);
      setImagePreview("");
      toastr.error("Error", "Failed to upload image");
    } finally {
      setIsImageUploading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!isFormValid) {
      toastr.warning("Incomplete Form", "Please enter sub category name");
      return;
    }
    
    if (!category) {
      toastr.error("Error", "No category data found");
      navigate(-1);
      return;
    }
    
    setIsSubmitting(true);
    
    // Prepare payload
    const payload = {
      name: formData.name,
      description: formData.description || "",
      image: imagePath || "",
      active: formData.status === "active",
    };
    
    console.log("Create Sub Category Payload:", payload);
    
    props.getDataFromAPI(
      `/partner/api/v1/product-categories/${category.id}/subcategories`,
      "POST",
      payload,
      (response) => {
        setIsSubmitting(false);
        const newId = response?.id || response?.data?.id || "N/A";
        const newName = response?.name || response?.data?.name || formData.name;
        setCreatedItemName(newName);
        setCreatedItemId(newId);
        setShowSuccessPopup(true);
        toastr.success("Success", "Sub category created successfully!");
      },
      (error) => {
        setIsSubmitting(false);
        toastr.error("Error", error?.message || "Failed to create sub category");
      }
    );
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleCloseSuccessPopup = () => {
    setShowSuccessPopup(false);
    navigate(-1);
  };

  if (!category) {
    return null;
  }

  return (
    <SubCategoryCreateComponent
      formData={formData}
      imagePreview={imagePreview}
      isSubmitting={isSubmitting || isImageUploading}
      isFormValid={isFormValid}
      category={category}
      onChange={handleChange}
      onStatusChange={handleStatusChange}
      onImageChange={handleImageChange}
      onSubmit={handleSubmit}
      onBack={handleBack}
      fileInputRef={fileInputRef}
      showSuccessPopup={showSuccessPopup}
      onSuccessClose={handleCloseSuccessPopup}
      createdItemName={createdItemName}
      createdItemId={createdItemId}
    />
  );
};

function mapStateToProps(state) {
  return { props: state };
}

export default connect(mapStateToProps, { getDataFromAPI })(SubCategoryCreateContainer);